import {useMemo} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {IRPStore} from "../../../app/rp_reducer";
import {ForYouBanner} from "../../../for_you/components/for_you_banner/ForYouBanner";
import {ISelectedRegion} from "../../../offer/list/actions/offer_list_selected_data_actions";
import {OfferType} from "../../../offer/types/OfferType";

export const PromotionConsultantBox = () => {
    const region = useSelector((state: IRPStore) => state.promotionList.region);
    const selectedRegion = useMemo<ISelectedRegion[]>(() => (region ? [{id: region.id} as ISelectedRegion] : []), [region]);

    return <ForYouBanner className={promotionConsultantBoxStyle} selectedRegion={selectedRegion} offerTypes={[OfferType.FLAT, OfferType.HOUSE]} />;
};

const promotionConsultantBoxStyle = css({
    px: 0
});
import {useMemo} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {IRPStore} from "../../../app/rp_reducer";
import {ForYouBanner} from "../../../for_you/components/for_you_banner/ForYouBanner";
import {ISelectedRegion} from "../../../offer/list/actions/offer_list_selected_data_actions";
import {OfferType} from "../../../offer/types/OfferType";

export const PromotionConsultantBox = () => {
    const region = useSelector((state: IRPStore) => state.promotionList.region);
    const selectedRegion = useMemo<ISelectedRegion[]>(() => (region ? [{id: region.id} as ISelectedRegion] : []), [region]);

    return <ForYouBanner className={promotionConsultantBoxStyle} selectedRegion={selectedRegion} offerTypes={[OfferType.FLAT, OfferType.HOUSE]} />;
};

const promotionConsultantBoxStyle = css({
    px: 0
});
